import type { UpdateAccountSettingsPwasPayload } from '@fourthwall/services/dist/MembershipsCreatorApiClient'

import type { FormValues } from './types'

export const getUpdateAccountSettingsPwasPayload = (
  formValues: FormValues,
): UpdateAccountSettingsPwasPayload => {
  const { appNameSetting, appName } = formValues

  return {
    customName: appNameSetting === 'custom' ? appName : undefined,
  }
}
